import { useState, useEffect, useCallback } from 'react'
import { isAuthenticated } from '../../../../../helpers'
import { API, API_ROUTER } from '../../../../../api'

export const useEventTournaments = (eventId) => {
  const [tournaments, setTournaments] = useState()
  const [pagination, setPagination] = useState(1)
  const [page, setPage] = useState(1)
  const [requestSuccess, setRequestSuccess] = useState(false)

  const fetchTournaments = useCallback(async () => {
    try {
      const response = await API.request({
        ...(isAuthenticated() ? API_ROUTER.events.getEventTournamentsAuth : API_ROUTER.events.getEventTournaments),
        pathKeys: {
          eventId: eventId,
          page: page ? page : 1,
          limit: 10,
        },
      })

      setTournaments(response.tournaments)
      setPagination(response.paginator)
      setRequestSuccess(true)
    } catch (err) {
      console.log(err)
    }
  }, [eventId, page])

  const handlePageChange = useCallback((event, value) => {
    setPage(value)
  }, [])

  useEffect(() => {
    fetchTournaments()
  }, [fetchTournaments])

  return {
    tournaments,
    pagination,
    requestSuccess,
    handlePageChange
  }
}

